<template>
  <material-card  :title="$t('views.wip.work_in_progress')"
  :color="$vuetify.theme.themes.light.warning"
    icon="warning">

      <v-container fill-height>
        <v-layout align-center>
          <v-flex>
            <h3 class="display-3"></h3>
            <span class="subheading">{{$t("views.wip.under_construction")}}</span>
            <v-divider class="my-3"></v-divider>
            <div class="title mb-3">{{$t("views.wip.wip")}}</div>
          </v-flex>
        </v-layout>
      </v-container>
  </material-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
  export default {
    name: "wip",
    components: {
    },
    computed: {
      ...mapGetters("common", ["messages"]),
    },
    methods: {
      /*$t(args) {
        console.log(this.messages, args)
        if (Object.keys(this.messages).indexOf(args) < 0) {
            this.messages[args]="TRANSLATION REQUIRED"
        }
        return "TRANSLATION REQUIRED";
    },*/
    }
  }
</script>